import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { PersonalInfo } from "@/components/PersonalInfo";
import { Expertise } from "@/components/Expertise";
import { Skills } from "@/components/Skills";
import { Experience } from "@/components/Experience";
import { Education } from "@/components/Education";
import { Achievements } from "@/components/Achievements";
import { Certifications } from "@/components/Certifications";
import { Interests } from "@/components/Interests";
import { Blogs } from "@/components/Blogs";
import { Testimonials } from "@/components/Testimonials";
import { CommunityImpact } from "@/components/CommunityImpact";
import { Contact } from "@/components/Contact";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <About />
      <PersonalInfo />
      <Expertise />
      <Skills />
      <Experience />
      <Education />
      <Achievements />
      <Certifications />
      <Interests />
      <Blogs />
      <Testimonials />
      <CommunityImpact />
      <Contact />
    </main>
  );
}
